import AuthenticateUser from "./guards/AuthenticateUser";
import RedirectIfAuthenticated from "./guards/RedirectIfAuthenticated";

export default [AuthenticateUser, RedirectIfAuthenticated];